import { connect } from "react-redux";
import { Link , useLocation} from "react-router-dom";
import { Button } from "@stripe/ui-extension-sdk/ui";
import { getWallet , paypalapi } from '../../actions/wallet';
import { getTransaction } from '../../actions/transaction';
import { useDispatch, useSelector } from "react-redux";
import store from '../../store';
import Input from '../../components/input/input';
import React, { useEffect, useState } from "react";
import GoSellDemo from "./checkout";
import PayPalButton from "./paypal";
import Modal from 'react-bootstrap/Modal';
import Alert from '../../components/alert/Alert';
import { setAlert } from '../../actions/alert';
import { useErrorBoundary } from "use-error-boundary";
import Skeleton from "./../../components/skeleton";
import { ErrorBoundary } from 'react-error-boundary';

const Wallet = ({ auth: { isAuthenticated, user } ,paypalapi}) => {


  const dispatch = useDispatch();
  const amount = useSelector(state => state.wallet);
  const transactions = store.getState().transaction

    useEffect(() => {
        document.title = 'Wallet';
    }, []);
  useEffect(() => {
    dispatch(getWallet());
    dispatch(getTransaction());
  }, []);

  //const [transactionCompleted, setTransactionCompleted] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const homepage_query = useLocation();
  const searchParams = new URLSearchParams(homepage_query.search);
  const storedValue = searchParams.get("value");
  console.log("coming from header",storedValue)

  if (storedValue){
    localStorage.removeItem('taps_check');
  }

  const check_open = localStorage.getItem('taps_check');

 
  const handleTransactionComplete = (message) => {
    console.log("enter in the func")
    //setTransactionCompleted(true);
    if (message == 'Payment failed'){
      dispatch(setAlert(message, 'danger'))
    }
    else{
      dispatch(setAlert(message, 'success'))
    }
    console.log(check_open)

  };


  const [formData, setFormData] = useState({
    wallet_amount: "",
    paymentMethod: "",
  });

  const [taps, setTaps] = useState({
    taps_checkout: false,
  });

  const [paypal, setPaypal] = useState({
    paypal_checkout: false,
  });

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [show, setShow] = useState(false);

  const { wallet_amount } = formData;

  const onChange = (e) => {
    setTaps({ taps_checkout: false });
    const inputValue = e.target.value;

    if (/^\d*$/.test(inputValue)) {
      setFormData({ ...formData, [e.target.name]: e.target.value });
      if (e.target.type === "radio") {
        setFormData({ ...formData, paymentMethod: e.target.value });
      } else {
        setFormData({ ...formData, [e.target.name]: e.target.value });
      }
      
    }
    else{
      dispatch(setAlert('Amount must be in digits','danger', 3000));
    }

    /*setFormData({ ...formData, [e.target.name]: e.target.value });
    if (e.target.type === "radio") {
      setFormData({ ...formData, paymentMethod: e.target.value });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }*/
  };



  const onSubmit = async (e) => {
    e.preventDefault(); // Prevent the default form submission behavior
    if(formData.wallet_amount && formData.paymentMethod == 'taps'){
      setTaps({ taps_checkout: true });
    }
    else if (formData.wallet_amount && formData.paymentMethod == 'paypal'){
      setPaypal({paypal_checkout:true});
      handleShow();
      localStorage.setItem('paypal_walletAmount', JSON.stringify(formData.wallet_amount));
      //dispatch(paypalapi(formData.wallet_amount));
    }else{
      dispatch(setAlert('Please select Payment method','danger', 3000));
    }
  };
  
  function scrollToTop() {
    window.scrollTo(0, 0);
  } 

  const handleDivClick = (method) => {
    setFormData(prevState => ({ ...prevState, paymentMethod: method }));
  };


  function ErrorFallback({error, resetErrorBoundary}) {
    return (
      <div role="alert">
        <p>Something went wrong:</p>
        <pre style={{color: 'red'}}>{error.message}</pre>
        <button onClick={resetErrorBoundary}>Try again</button>
      </div>
    )
  }
  


  return (
    
    <section className="main-page page-dashboard">
    <div className="container">
      <form onSubmit={(e) => onSubmit(e)}>
        <Alert />
          {/* First Row */}
          <div className="row">
            <div className="col-md-12">
              <div className="rounded">
                  <div className="card-body1">
                      <div className="row" style={{borderBottom: '3px dotted lightgrey'}}>
                          <div className="col-md-3 text-center border-box">
                              <p style={{ textAlign: 'left' }}> Enter Amount in USD</p>
                              <Input
                                parentclass={`user`}
                                labelfor={`Add Money to Your Wallet.`}
                                id={`user1`}
                                className="form-control"
                                // label={`Username`}
                                group={true}
                                name={'wallet_amount'} // Change this to 'wallet_amount'
                                iconType={null}
                                required={true}
                                type={'text'}
                                value={formData.wallet_amount}
                                handlerOnChange={(e) => onChange(e)}
                                >
                              </Input>
                          </div>
                          <div className="col-md-3 text-center border-box" style={{borderRight: '2px dotted lightgrey'}}>
                          </div>
                          <div className="col-md-3 text-center border-box" style={{borderLeft: '2px dotted lightgrey'}}>
                          </div>
                          <div className="col-md-3 text-center border-box">
                              <p style={{ textAlign: 'left' }} > Total Amount </p>
                              {amount.walletAmount === null ? (
                                <div className="d-flex w-100">
                                  <Skeleton width={140} height={50} />
                                </div>
                              ): (
                                <h1 className="font-weight-bold m-0 text-left" text-left>
                                  ${amount.walletAmount}
                                </h1>
                              )}
                          </div>
                      </div>
                  </div>
              </div>
            </div>
          </div>

          
          {/* Second Row */}
          <div className="payment-method-title">
            Choose a payment method <span>(Click one of the options below)</span>
          </div>
            
          <div className="py-3 d-flex align-item-center join-now">
            <div className="col-md-12">
              <div className="mb-3 border-0 bg-white shadow-sm rounded ">
                  <div className="card-body1">
                    <div className="row">
                        <div className="col-md-3 text-center border-box">
                        </div>
                        <div className={`col-md-3 text-center border-box ${formData.paymentMethod === "taps" ? 'selected1' : ''}`} onClick={() => handleDivClick("taps")}>
                          <input type="radio" name="paymentMethod" value="taps" checked={formData.paymentMethod === "taps"} onChange={onChange} style={{display: 'none'}}/>
                          <div style={{ maxHeight: '100%', overflow: 'hidden' }}>
                            <img
                              src="assets/images/Taps_logo.png"
                              alt=" Pay with Taps"
                              style={{ maxWidth: '70%', height: '70%', width: 'auto' }}
                            />
                          </div>
                          <p className="newp" style={{marginTop: '8%'}}> Pay with Taps</p>
                        </div>  
                        <div className={`col-md-3 text-center border-box ${formData.paymentMethod === "paypal" ? 'selected1' : ''}`} onClick={() => handleDivClick("paypal")}>
                          <input type="radio" name="paymentMethod" value="paypal" checked={formData.paymentMethod === "paypal"} onChange={onChange} style={{display: 'none'}}/>
                          <div style={{ maxHeight: '100%', overflow: 'hidden' }}>
                            <img
                              src="assets/images/Paypal_logo.png"
                              alt="Pay with PayPal"
                              style={{ maxWidth: '70%', height: '70%', width: 'auto' }}
                            />
                          </div>
                          <p className="newp" style={{marginTop: '8%'}}>Pay with PayPal</p>
                        </div>
                        <div className="col-md-3 text-center border-box">
                        </div>
                  </div>  
              </div>
            </div>
          </div>

      </div>


        <div className="centered-button-container">
          <p style={{ marginBottom: '20px' }}>
              Click the button below to be re-directed to the respective website to complete your transaction.
          </p>
          <button className="btn btn-primary btn1-block" type="submit">
            Continue
          </button>
        </div>
          
      
      </form>
    </div>
   
    <div className="row">
      <div className="col-lg-12"></div>
    </div>
      {/** 
      <button
        className="btn btn-default btn-block"
        type="submit"
      >
        Create
      </button>*/}

      {/* <>
      {didCatch ? (
        <div className="bg-danger mx-auto mt-2 px-2 py-1 rounded" style={{width:"max-content"}}>
          <h4 className="text-center pt-3" style={{color: "white"}}>Tap payment is unavailable temporarily</h4>
        </div>
      ) : (
      )}
      </> */}
        <ErrorBoundary fallback={ErrorFallback} onReset={()=>{}} >
          {taps.taps_checkout && (
            <GoSellDemo walletAmount={formData.wallet_amount} email={user.email}/>
          )}
        </ErrorBoundary>
        
      {paypal.paypal_checkout && (
          <>
          {show == true?
            <Modal show={show} size="sm" aria-labelledby="contained-modal-title-vcenter" centered onHide={handleClose}>
    
                <Modal.Header closeButton>
                    <Modal.Title>PayPal</Modal.Title>
                </Modal.Header>
                
                <Modal.Body>
                <PayPalButton walletAmount={formData.wallet_amount} email={user.email} onTransactionComplete={handleTransactionComplete} />
                </Modal.Body>
                                        
                <Modal.Footer>
                </Modal.Footer>
            </Modal> 
            :null}
          </>
      )}

      {console.log("endpoint" , check_open )}
      {console.log("show" , taps.taps_checkout )}
      {check_open ?
      <GoSellDemo walletAmount={"0"} email={user.email}/>:
      null}

    </section>
    
    
  );
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps,{paypalapi})(Wallet);